import { useQuery } from '@tanstack/react-query';

import { getAdminFiscalProfile } from '../services/fiscal-admin.service';

/** Profilo fiscale admin — 404 (profilo mai compilato) non va in retry. */
export function useAdminFiscalProfile(professionalId: string) {
  return useQuery({
    queryKey: ['professionals', 'admin', professionalId, 'fiscal-profile'],
    queryFn: () => getAdminFiscalProfile(professionalId),
    enabled: !!professionalId,
    retry: false,
  });
}
